module.exports = __webpack_public_path__ + "img/nap_thumb_4.b6881df0.jpg";